var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHalfFilledStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4259 15.651L31.0955 3.65272C29.7823 1.16371 26.2176 1.1637 24.9044 3.65272L18.574 15.651C18.5017 15.7881 18.3698 15.8839 18.217 15.9103L4.84983 18.2232C2.07683 18.703 0.975275 22.0932 2.93666 24.1113L12.3915 33.8395C12.4996 33.9507 12.5499 34.1057 12.5279 34.2592L10.5968 47.6869C10.1962 50.4724 13.0801 52.5677 15.6055 51.3259L27.7793 45.34C27.9184 45.2716 28.0814 45.2716 28.2206 45.34L40.3943 51.3259C42.9198 52.5677 45.8037 50.4724 45.4031 47.6869L43.472 34.2592C43.45 34.1057 43.5003 33.9507 43.6084 33.8395L53.0632 24.1113C55.0246 22.0932 53.9231 18.703 51.1501 18.2232L37.7828 15.9103C37.6301 15.8839 37.4982 15.7881 37.4259 15.651Z",
    fill: "#D9D9D9",
    stroke: "#58BCBE",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4259 15.651L31.0955 3.65272C29.7823 1.16371 26.2176 1.1637 24.9044 3.65272L18.574 15.651C18.5017 15.7881 18.3698 15.8839 18.217 15.9103L4.84983 18.2232C2.07683 18.703 0.975275 22.0932 2.93666 24.1113L12.3915 33.8395C12.4996 33.9507 12.5499 34.1057 12.5279 34.2592L10.5968 47.6869C10.1962 50.4724 13.0801 52.5677 15.6055 51.3259L27.7793 45.34C27.9184 45.2716 28.0814 45.2716 28.2206 45.34L40.3943 51.3259C42.9198 52.5677 45.8037 50.4724 45.4031 47.6869L43.472 34.2592C43.45 34.1057 43.5003 33.9507 43.6084 33.8395L53.0632 24.1113C55.0246 22.0932 53.9231 18.703 51.1501 18.2232L37.7828 15.9103C37.6301 15.8839 37.4982 15.7881 37.4259 15.651Z",
    fill: "url(#paint0_linear_511_673)",
    stroke: "#58BCBE",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_511_673",
    x1: 54.6295,
    y1: 26.3262,
    x2: 1.37036,
    y2: 26.3262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFC425"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfFilledStar);
export default __webpack_public_path__ + "static/media/halfFilledStar.6ae7c6d5fa3e3f83ed0d15d574255de4.svg";
export { ForwardRef as ReactComponent };